(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		GamePanel = include('PrimalSpringrollTemplate.GamePanel'),
		Delay = include('springroll.DelayedCall');

	/**
	 * The logic for the title state
	 * @class PrimalSpringrollTemplate.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var GameState = function(options)
	{
		BaseState.call(this, new GamePanel(), options);

		this.startTimeout = this.startTimeout.bind(this);
		this.stopTimeout = this.stopTimeout.bind(this);
		this.returnToIdleAnimation = this.returnToIdleAnimation.bind(this);

	};

	//Extend the base state
	var p = extend(GameState, BaseState);

	/**
	 * After assets are loaded and state is fully entered
	 * @method  enterDone
	 */
	p.enterDone = function()
	{
		app.state = this;
		this.timeoutCount = 0;

		//Setup variables
		this.flashNumber = -1;
		this.buttons = this.panel.shelfPositions;
		this.wrongAnswerCount = 0;
		this.correct = 0;
		this.chosenIndex = -1;
		this.panel.round = 2;
		this.firstTime = true;

		//Setup buttons in order to be able to shrink them
		for (var i = 0; i < this.buttons.length; i++) {
			this.buttons[i].chosen = false;
			this.buttons[i].initialX = this.buttons[i].scaleX;
			this.buttons[i].initialY = this.buttons[i].scaleY;
		}

		//Setup stage objects
		for (var j = 0; j < this.panel.slots.length; j++) {
			this.panel.slots[j].framerate = 12;
		}
		this.panel.monster.mc.head.framerate = 12;

		var callback = function() {
			this.intro();
		}.bind(this);

		//Play greeting (only happens first time player enters game)
		this.panel.playHeadAnimation(this.panel.headAnimations.enter, 0, callback);
	};

	//Plays intro dialogue and moves belt into scene
	p.intro = function() {
		var talk = function() {
			this.panel.playCookieAnimation("talk");
		}.bind(this);

		var callback = function() {
			this.returnToIdleAnimation();
			this.firstTime = false;
			this.startTimeout();
		}.bind(this);

		createjs.Tween.get(this.panel.belt)
			.to({x: 560}, 4000)
			.call(function() {
				this.optionsAvailable();
			}.bind(this));

		this.panel.playHeadAnimation(this.panel.headAnimations.intro, 0, callback);
	};

	//Flashes belt slots and calls out food names of the current food on the belt
	p.flashPattern = function() {
		this.flashNumber++;
		if (this.flashNumber >= this.panel.slots.length) {
			this.flashNumber = -1;
			if (this.correct == 1) {
				this.flashNumber = 2;
				this.rightAnswer();
			}
			this.correct = 0;
		} else {
			createjs.Tween.get(this)
				.call(function(){
					this.panel.slots[this.flashNumber].gotoAndPlay("flash");
					this.foodSounds(this.panel.beltPositions[this.flashNumber+3]);
				}.bind(this));
		}
	};

	//Allows player to click food on shelf + enables hover sounds
	p.optionsAvailable = function() {
		var talk = function() {
			this.panel.playCookieAnimation("talk");
		}.bind(this);

		if (!this.firstTime) {
			this.returnToIdleAnimation();
			this.startTimeout();
		}
		for (var j = 0; j < this.panel.shelfPositions.length; j++) {
			var button = this.buttons[j];
			button.cursor = "pointer";
			button.index = j;
			button.on('click', this.onShelfClick, this, false, button);
			button.on('mouseover', this.onShelfHover, this, false, button);
		}
	};

	//Has cookie monster say names of food player hovers over
	p.onShelfHover = function(event, button) {

		if (!this.firstTime) {
			app.voPlayer.play(button.answer);
			this.panel.playHeadAnimation(button.answer, 0, this.returnToIdleAnimation);
		}
	};

	//Plays sound of food on current flashing belt slot
	p.foodSounds = function(beltFood) {
		var callback = function() {
			this.flashPattern();
		}.bind(this);
		app.voPlayer.play(beltFood.answer, callback);
		this.panel.playHeadAnimation(beltFood.answer);
	};

	//Populates the belt with the selected food + checks answer
	p.onShelfClick = function(event, button) {
		this.stopTimeout();
		this.firstTime = false;
		button.chosen = true;
		for (var i = 0; i < this.panel.shelfPositions.length; i++) {
			this.buttons[i].removeAllEventListeners();
			this.buttons[i].cursor = "CursorDefault";
		}
		if (button.answer == this.panel.answer) {
			this.correct = 1;
			this.panel.beltPositions[this.panel.missingIndex + 6].answer = button.answer;
			this.panel.beltPositions[this.panel.missingIndex + 6].addChild(button.children[2]);
			this.flashPattern();
		} else {
			button.chosen = false;
			this.chosenIndex = button.index;
			this.wrongAnswer();
		}
	};

	//Handles correct answer
	p.rightAnswer = function() {

		var callback = function() {
			this.eatFood();
		}.bind(this);

		var voList = ["033_CM_Payoff1", "034_CM_Payoff2", "payoff1", "payoff2"];
		var index = Math.floor(Math.random() * 2);
		app.voPlayer.play(voList[index]);
		this.panel.playHeadAnimation(voList[index+2], 1, callback);

		createjs.Tween.get(this.panel.belt)
			.wait(1000)
			.to({x: 1700}, 2000)
			.to({x: -450});

		createjs.Tween.get(this.buttons)
			.wait(1000)
			.call(function() {
				for (var i = 0; i < this.buttons.length; i++) {
					if (!this.buttons[i].chosen) {
						this.shrinkItem(this.buttons[i]);
					}
				}
			}.bind(this));

		createjs.Tween.get(this.panel.bag)
			.wait(1300)
			.call(function() {
				this.gotoAndStop("filling");
			})
			.wait(1000)
			.call(function() {
				this.gotoAndStop("full");
			});
	};	

	//Cookie monster eats food with correct sounds
	p.eatFood = function() {
		var callback = function() {
			this.nextRound();
		}.bind(this);

		createjs.Tween.get(this)
			.call(function() {
				this.panel.playCookieAnimation("eat");
				app.voPlayer.play("CM_Eating");
			}.bind(this))
			.wait(500)
			.call(function() {
				this.panel.bag.visible = false;
			}.bind(this))
			.wait(6000)
			.call(function() {
				var payoffIndex = Math.floor(Math.random() * this.panel.headAnimations.payoff.length);
				this.panel.playHeadAnimation(this.panel.headAnimations.payoff[payoffIndex], 1, callback);
			}.bind(this));
	};

	//Resets stage for next round
	p.nextRound = function() {
		var instruxIndex = Math.floor(Math.random() * this.panel.headAnimations.instrux.length);
		this.panel.playHeadAnimation(this.panel.headAnimations.instrux[instruxIndex]);

		this.panel.resetStage();
		this.panel.bag.visible = true;
		this.wrongAnswerCount = 0;

		for (var i = 0; i < this.buttons.length; i++) {
			this.buttons[i].chosen = false;
			this.buttons[i].scaleX = this.buttons[i].initialX;
			this.buttons[i].scaleY = this.buttons[i].initialY;
		}

		createjs.Tween.get(this.panel.belt)
			.wait(1000)
			.to({x: 560}, 3000)
			.call(function(){
				this.flashPattern();
			}.bind(this))
			.wait(3000)
			.call(function() {
				this.optionsAvailable();
			}.bind(this));
	};

	//Shrinks shelf items during transition
	p.shrinkItem = function(button) {
		createjs.Tween.get(button)
			.to({scaleX: 0, scaleY: 0}, 2000);
	};

	//Handles wrong answer
	p.wrongAnswer = function() {
		var callback = function() {
			if (this.wrongAnswerCount == 3) {
				this.panel.playHeadAnimation(this.panel.answer);
				app.voPlayer.play(this.panel.answer);
				this.wrongAnswerCount--;
			}
			this.optionsAvailable();
		}.bind(this);

		this.panel.playHeadAnimation(this.panel.headAnimations.wrong[this.wrongAnswerCount], 0, callback);
		this.wrongAnswerCount++;

		createjs.Tween.get(this)
			.call(function() {
				this.panel.playCookieAnimation("cringe");
				this.voPlayer.play("boing");
			}.bind(this));
	};

	p.returnToIdleAnimation = function() {
		// use as callback to most VO
		this.panel.playCookieAnimation("pointToShelf");
	};

	//Handles timeout (has cookie monster prompt the player every 15 seconds)
	p.startTimeout = function(resetCount) {
		if (typeof resetCount === "undefined") {
			resetCount = true;
		}
		if (this.timeout) {
			this.timeout.destroy();
		}

		if (resetCount) {
			this.timeoutCount = 0;
		}

		// timer logic
		this.timeout = new Delay((function(){
			// set analytics vars
			this.timeoutCount += 1;

			if (app.voPlayer.playing) {
				// don't interrupt playing VO
				this.startTimeout(true);
				return;
			}

			var voList = [];
			var headAnim;
			var callback = function() {
				this.returnToIdleAnimation();
				app.state.startTimeout(false);
			}.bind(this);

			if (this.timeoutCount % 3 === 1) {
				// this is the first timeout
				headAnim = this.panel.headAnimations.timeout[0];

				// new date for TO ReEngage event
				this.timeoutStartTime = Date.now();

			} else if (this.timeoutCount % 3 === 2) {

				headAnim = this.panel.headAnimations.timeout[1];
				
				// new date for TO ReEngage event
				this.timeoutStartTime = Date.now();

			} else {
				// 2nd+ timeout
				headAnim = this.panel.headAnimations.timeout[2];
			}

			this.panel.playHeadAnimation(headAnim, 0, callback);
			
		}.bind(this)), 15000);
	};

	//Stops the timeout handler
	p.stopTimeout = function() {
		if (this.timeout) {
			this.timeout.destroy();
		}
		app.state.timeoutCount = 0;
	};

	/**
	 * When the state starts to exit, before transition
	 * @method  exitStart
	 */
	p.exitStart = function()
	{
		this.stopTimeout();
		
	};

	//Assign to namespace
	namespace('PrimalSpringrollTemplate').GameState = GameState;
}());